import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAdminAuth } from '../auth/AdminAuthContext';

export default function Login() {
  const { isAuthed, login } = useAdminAuth();
  const nav = useNavigate();
  const [secret, setSecret] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (isAuthed) return <Navigate to="/" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!secret.trim()) {
      setError('Please enter the admin secret.');
      return;
    }

    setLoading(true);
    try {
      await login(secret.trim());
      nav('/', { replace: true });
    } catch (err) {
      setError(err.message || 'Authentication failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="container">
      <div className="card">
        <h1>🔐 Admin Login</h1>
        <p className="muted">Enter your admin secret to continue.</p>
        <form onSubmit={onSubmit}>
          <label htmlFor="adminSecret">Admin Secret</label>
          <input
            id="adminSecret"
            type="password"
            value={secret}
            onChange={e => setSecret(e.target.value)}
            placeholder="••••••••••"
            autoFocus
            disabled={loading}
          />
          {error && <div className="error">{error}</div>}
          <button 
            type="submit" 
            className="btn btn--primary" 
            style={{ width: '100%', marginTop: 8 }}
            disabled={loading}
          >
            {loading ? 'Validating...' : 'Sign In'}
          </button>
        </form>
      </div>
    </main>
  );
}